require('royalslider');

$(() => {
    initSlider();

    $(window).on('orientationchange resize', initSlider);

});

var mobileSliderActive = false;
var desktopSliderActive = false;

function initSlider() {
    setTimeout(function () {
        if ($(".royalSlider").length > 0) {
            if (!mobileSliderActive) {
                mobileSlider = $(".royalSlider").royalSlider({
                    keyboardNavEnabled: true,
                    controlNavigation: 'bullets',
                    imageScalePadding: 4,
                    autoCenter: false,
                    autoScaleSlider: false,
                    autoHeight: false,
                    numImagesToPreload: 0,
                    fullscreen: {
                        enabled: true,
                        nativeFS: false
                    }
                });

                mobileSliderActive = true;
            }
            $("#Gallery").css("display", "block");
        } else {
            $("#Gallery").css("display", "none");
        }
    }, 100);
}